// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o4-c";
export var backButton = "_o4-4";
export var backIcon = "_o4-5";
export var chevronShortcut = "_o4-6";
export var container = "_o4-1";
export var editor = "_o4-8";
export var editorWrapper = "_o4-7";
export var prefix = "_o4-2";
export var searchIcon = "_o4-3";
export var suffix = "_o4-9";
export var suffixContent = "_o4-a";
export var suffixText = "_o4-b";
export var wrapper = "_o4-0";